export const TOKENS = {
  TESTING: globalThis.btoa('testing|email'),
  ERROR: globalThis.btoa('error|email'),
  INVALID: 'non-base64-token',
} as const;

export type Tokens = keyof typeof TOKENS;
